exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dash-cell[data-v-58517304] {\n    /*text-align: center;*/\n    background: #f5f5f5;\n    border: 1px solid #eaeaea;\n    padding: 20px;\n}\n", ""]);

// exports
